export const getApiUrl = () => {
  try {
    const remote = localStorage.getItem('PROXY_URL');

    if (remote) {
      return remote + 'api/';
    }

    return '/api/';
  } catch (e) {
    return '/api/';
  }
};
